<template>
    <div
        class="o-mobile-message mobile-message"
        v-if="isMessageShow"
    >   
        <svg-icon
            original
            name="icons/close-circle"
            class="o-mobile-message__close-icon"
            @click="toggleMessage()"
        />
        <div class="o-mobile-message__title">{{title}}</div>
        <div 
            class="o-mobile-message__description" 
            v-html="description"
        />
    </div>
</template>

<script>

export default {
    name: 'OMobileMessage',
    props: {
        title: {
            type: String,
            default: ''
        },
        description: {
            type: String,
            default: ''
        }
    },
    data() {
        return {
            isMessageShow: true
        }
    },
    methods: {
        toggleMessage(isShow = false) {
            this.isMessageShow = isShow
        }
    }
}
</script>

<style lang="scss">
@import "o-mobile-message";
</style>
